import AnovaRegular from '@sas/filament-fonts/anova/Anova-Regular.woff2';
import AnovaLight from '@sas/filament-fonts/anova/Anova-Light.woff2';
import AnovaItalic from '@sas/filament-fonts/anova/Anova-Italic.woff2';
import AnovaLightItalic from '@sas/filament-fonts/anova/Anova-LightItalic.woff2';
import AnovaBold from '@sas/filament-fonts/anova/Anova-Bold.woff2';
import AnovaBoldItalic from '@sas/filament-fonts/anova/Anova-BoldItalic.woff2';

import AnovaUIRegular from '@sas/filament-fonts/anova-ui/AnovaUI-Regular.woff2';
import AnovaUILight from '@sas/filament-fonts/anova-ui/AnovaUI-Light.woff2';
import AnovaUIItalic from '@sas/filament-fonts/anova-ui/AnovaUI-Italic.woff2';
import AnovaUILightItalic from '@sas/filament-fonts/anova-ui/AnovaUI-LightItalic.woff2';
import AnovaUIBold from '@sas/filament-fonts/anova-ui/AnovaUI-Bold.woff2';
import AnovaUIBoldItalic from '@sas/filament-fonts/anova-ui/AnovaUI-BoldItalic.woff2';

// We purposefully differ from Icon.tsx to get the smaller woff2 version
import icons from '@sas/react-svg/font/sas-icons-regular.woff2';

// no-op import. Used in the rollup build to verify that our font definitions are up-to-date.
import '@sas/filament-fonts/font-faces.css';

/**
 * Declares the built-in fonts in JS. Needed in va-report-components, where we
 * bundle font assets and remove all @font-face declarations from CSS.
 */
export async function initFonts() {
  for (const font of getFontDeclarations()) {
    try {
      document.fonts.add(font);
    } catch (e) {
      // @font-face declaration may already exist
    }
  }
  return Promise.all([
    document.fonts.load('12px sas-icons'),
    document.fonts.load('12px Anova'),
    document.fonts.load('12px "Anova UI"'),
    document.fonts.load('bold 12px "Anova UI"'),
  ]);
}

/**
 * Font definitions copied from https://github.com/sas-institute-rnd-product/design-system-filament-ui/blob/main/src/system/theme/components/GlobalStyles/GlobalFontFamilyStyles.ts
 * The declarations here must be kept up-to-date with fonts.json.
 */
function getFontDeclarations() {
  return [
    // Anova
    new FontFace('Anova', `url(${AnovaRegular})`, {
      weight: '400',
      style: 'normal',
    }),
    new FontFace('Anova', `url(${AnovaLight})`, {
      weight: '300',
      style: 'normal',
    }),
    new FontFace('Anova', `url(${AnovaItalic})`, {
      weight: '400',
      style: 'italic',
    }),
    new FontFace('Anova', `url(${AnovaLightItalic})`, {
      weight: '300',
      style: 'italic',
    }),
    new FontFace('Anova', `url(${AnovaBold})`, {
      weight: '700',
      style: 'normal',
    }),
    new FontFace('Anova', `url(${AnovaBoldItalic})`, {
      weight: '700',
      style: 'italic',
    }),

    // Anova Light. Not defined in Nova, but selectable in VA
    new FontFace('Anova Light', `url(${AnovaLight})`, {
      weight: '300',
      style: 'normal',
    }),
    new FontFace('Anova Light', `url(${AnovaLightItalic})`, {
      weight: '300',
      style: 'italic',
    }),

    // Anova UI
    new FontFace('Anova UI', `url(${AnovaUIRegular})`, {
      weight: '400',
      style: 'normal',
    }),
    new FontFace('Anova UI', `url(${AnovaUIItalic})`, {
      weight: '400',
      style: 'italic',
    }),
    new FontFace('Anova UI', `url(${AnovaUILight})`, {
      weight: '300',
      style: 'normal',
    }),
    new FontFace('Anova UI', `url(${AnovaUILightItalic})`, {
      weight: '300',
      style: 'italic',
    }),
    new FontFace('Anova UI', `url(${AnovaUIBold})`, {
      weight: '700',
      style: 'normal',
    }),
    new FontFace('Anova UI', `url(${AnovaUIBoldItalic})`, {
      weight: '700',
      style: 'italic',
    }),

    // Anova UI Light. Not defined in Nova, but selectable in VA
    new FontFace('Anova UI Light', `url(${AnovaUILight})`, {
      weight: '300',
      style: 'normal',
    }),
    new FontFace('Anova UI Light', `url(${AnovaUILightItalic})`, {
      weight: '300',
      style: 'italic',
    }),

    // sas-icons
    new FontFace('sas-icons', `url(${icons})`, {
      weight: 'normal',
      style: 'normal',
    }),
  ];
}
